import FalconCloseButton from '@/components/common/FalconCloseButton';
import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideCannibalizationsModal } from '@/app/KeywordTracker/reducers/cannibalizationsModal';
import _ from 'lodash';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import RankRenderer from '@/app/common/components/CellRenderers/RankRenderer';

function CannibalizationsModal() {
  const dispatch = useDispatch();
  const cannibalizationData = useSelector(state => state.cannibalizationsModal);
  return (
    <>
      <Modal
        show={cannibalizationData?.keyword}
        onHide={() => dispatch(hideCannibalizationsModal())}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <>
          <Modal.Header>
            <Modal.Title>
              مشکل Keyword Cannibalization (همنوع خواری)
            </Modal.Title>
            <FalconCloseButton
              onClick={() => dispatch(hideCannibalizationsModal())}
            />
          </Modal.Header>
          <Modal.Body>
            <div className="fs-0 lh-lg">
              سایت شما در آخرین به‌روزرسانی انجام شده ، در کلمه کلیدی{' '}
              <strong> {cannibalizationData?.keyword}</strong> به دلیل داشتن{' '}
              <strong> چند صفحه پیدا شده در نتایج گوگل </strong> دارای مشکل
              Keyword Cannibalization (همنوع خواری) در سئو هست.{' '}
              <a
                href="https://mizfa.tools/article/keyword-cannibalization/"
                target="_blank"
                rel="noreferrer noopener"
              >
                {' '}
                (لینک آموزش رفع این مشکل){' '}
              </a>{' '}
              این صفحات را در لیست زیر می توانید مشاهده کنید :
            </div>
            <div className="mt-3">
              <AgGridWrapper
                height="180px"
                settings={{ pagination: false }}
                data={cannibalizationData?.data}
                columns={[
                  {
                    field: 'rank',
                    sort: 'asc',
                    type: 'number',
                    title: 'رتبه',
                    width: 80,
                    searchable: true,
                    cellRenderer: params => <RankRenderer rank={params.value} />
                  },
                  {
                    flex: 1,
                    searchable: true,
                    field: 'found_url',
                    type: 'string',
                    title: 'صفحه پیدا شده',
                    cellRenderer: params =>
                      params.value && (
                        <div className="d-flex align-items-center gap-2">
                          <URLRenderer url={params.value} />
                        </div>
                      )
                  }
                ]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => dispatch(hideCannibalizationsModal())}
            >
              بستن
            </Button>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );
}
export default CannibalizationsModal;
